import React from 'react'
import ListCustomerTableItem from "./ListCustomerTableItem"

function ListCustomerTableBody(props) {
    const {error, listContact, arrSelected, onSelected} = props

    return (
        <tbody className="TableBody">
        {
            !!listContact && listContact.length > 0 ? listContact.map((item, index) => (
                <ListCustomerTableItem key={index} item={item} arrSelected={arrSelected}
                                       onSelected={onSelected}/>
            )) : <tr className="NoRecord">
                <td colSpan={6}>Không có bản ghi nào</td>
            </tr>
        }
        {
            !!error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={6}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default ListCustomerTableBody
